<template>
  <div>
    <div id="wrapper">
      <header style="background-color: black; padding: 10px">
        <nav id="nav" class="clearfix" style="position: relative">
          <ul>
            <li id="save"><a href="#">Guardar</a></li>
            <li id="load"><a href="#">Cargar</a></li>
            <li id="from_html"><a href="#">Cargar html</a></li>
            <li id="rectangle"><a href="#">Rectangulo</a></li>
            <li id="circle"><a href="#">Circulo</a></li>
            <li id="polygon"><a href="#">Polígono</a></li>
            <li id="edit"><a href="#">Editar</a></li>
            <li id="to_html"><a href="#">Ver html</a></li>
            <li id="preview"><a href="#">Vista previa</a></li>
            <li id="clear"><a href="#">Borrar</a></li>
            <li id="new_image"><a href="#">Nueva imagen</a></li>
            <li id="show_help"><a href="#">?</a></li>
          </ul>
        </nav>
        <div id="coords"></div>
        <div id="debug"></div>
      </header>

      <div id="image_wrapper">
        <div id="image">
          <img src="" alt="#" id="img" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.2"
            baseProfile="tiny"
            id="svg"
          ></svg>
        </div>
      </div>
    </div>

    <!-- For html image map code -->
    <div id="code">
      <span class="close_button" title="close"></span>
      <div id="code_content"></div>
    </div>

    <!-- Edit details block -->
    <form id="edit_details">
      <h5 style="color: white">Atributos</h5>
      <span class="close_button" title="close"></span>
      <p>
        <label for="href_attr" style="color: white">href</label>
        <input type="text" id="href_attr" />
      </p>
      <p>
        <label for="alt_attr" style="color: white">alt</label>
        <input type="text" id="alt_attr" />
      </p>
      <p>
        <label for="title_attr" style="color: white">title</label>
        <input type="text" id="title_attr" />
      </p>
      <button id="save_details">Guardar</button>
    </form>

    <!-- From html block -->
    <div id="from_html_wrapper">
      <form id="from_html_form">
        <h5>Loading areas</h5>
        <span class="close_button" title="close"></span>
        <p>
          <label for="code_input">Enter your html code:</label>
          <textarea id="code_input"></textarea>
        </p>
        <button id="load_code_button">Load</button>
      </form>
    </div>

    <!-- Get image form -->
    <div id="get_image_wrapper">
      <div id="get_image" style="width: 30%">
        <span title="close" class="close_button"></span>
        <div id="logo_get_image">
          <a href="">
            <img src="" alt="" />
          </a>
        </div>
        <div id="loading">Cargando...</div>
        <div id="file_reader_support">
          <label>Arrastrar imagen</label>
          <div id="dropzone" style="width: 80%; margin: auto">
            <span class="clear_button" title="clear">x</span>
            <img src="" alt="preview" id="sm_img" />
          </div>
        </div>
        <label
          style="cursor: pointer"
          title="Seleccionar una imagen para el auditorio"
        >
          <i class="material-icons" style="font-size: 60px; color: #777777"
            >add_a_photo</i
          >
          <input
            type="file"
            @change="getImageAuditorio"
            accept="image/*"
            name="imgInput"
            style="display: none"
            id="imgInput"
            required
          />
        </label>
        <label for="url">Digite una url</label>
        <span id="url_wrapper" style="display: block">
          <span class="clear_button" title="clear">x</span>
          <input type="text" id="url" />
        </span>
        <button id="button" class="btn light-green white--text">Mapear</button>
      </div>
    </div>

    <!-- Help block -->
    <div id="overlay"></div>
    <div id="help">
      <span class="close_button" title="close"></span>
      <div class="txt">
        <section>
          <h2>Main</h2>
          <p>
            <span class="key">F5</span> &mdash; reload the page and display the
            form for loading image again
          </p>
          <p>
            <span class="key">S</span> &mdash; save map params in localStorage
          </p>
        </section>
        <section>
          <h2>Drawing mode (rectangle / circle / polygon)</h2>
          <p>
            <span class="key">ENTER</span> &mdash; stop polygon drawing (or
            click on first helper)
          </p>
          <p>
            <span class="key">ESC</span> &mdash; cancel drawing of a new area
          </p>
          <p>
            <span class="key">SHIFT</span> &mdash; square drawing in case of a
            rectangle and right angle drawing in case of a polygon
          </p>
        </section>
        <section>
          <h2>Editing mode</h2>
          <p><span class="key">DELETE</span> &mdash; remove a selected area</p>
          <p>
            <span class="key">ESC</span> &mdash; cancel editing of a selected
            area
          </p>
          <p>
            <span class="key">SHIFT</span> &mdash; edit and save proportions for
            rectangle
          </p>
          <p>
            <span class="key">I</span> &mdash; edit attributes of a selected
            area (or dblclick on an area)
          </p>
          <p>
            <span class="key">CTRL</span> + <span class="key">C</span> &mdash; a
            copy of the selected area
          </p>
          <p><span class="key">&uarr;</span> &mdash; move a selected area up</p>
          <p>
            <span class="key">&darr;</span> &mdash; move a selected area down
          </p>
          <p>
            <span class="key">&larr;</span> &mdash; move a selected area to the
            left
          </p>
          <p>
            <span class="key">&rarr;</span> &mdash; move a selected area to the
            right
          </p>
        </section>
      </div>
    </div>

    <!-- <center>
            <v-form @submit.prevent="saveImagenAuditorio">              
           
                <v-card
                    max-width="80%"
                    style="margin-top: 30px;"
                >
                    <div style="width: 80%; margin: auto;">
                        <br>
                        <h4 align="left">Ingrese imagen mapeada</h4>
                        <br>
                        <v-text-field
                            type="file"                     
                            accept="image/*" 
                            v-model="idAuditorio.url_imagen"                
                            label="Imagen Archivo"
                            prepend-icon="file"                        
                            color="lime darken-4" 
                        ></v-text-field>
                        <br><br><br>
                        <h4 align="left">Ingrese texto HTML mapeado</h4>                
                        <v-textarea          
                            v-model="idAuditorio.codigo_mapeado"
                            color="lime darken-4"                    
                        ></v-textarea>

                        <v-btn color="success" type="submit" text>Guardar</v-btn>
                        <br><br>
                    </div>                   
                    
                </v-card>  

            </v-form>   
            <br><br>
        </center> -->
  </div>
</template>

<script>
export default {
  name: "Auditorio",
  props: ["idAuditorio"],
  data: () => ({
    formMapeo: {
      imagen: "",
      html: "",
    },
  }),
  methods: {
    async setImagen(i) {
      const formData = new FormData();
      formData.append("imagen", this.imagenesEvento[i]);
      await this.$store
        .dispatch("imagen/newImagen", formData)
        .then((response) => {
          this.setImagenEvento();
        });
    },
    async setImagenAuditorio() {
      await this.$store.dispatch("evento/newEventoImagen", {
        id_evento: this.evento.id,
        id_imagen: this.imagen.id,
      });
    },
    saveImagenAuditorio() {},
    getImageAuditorio(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          $("#sm_img").attr("src", e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
        $("#sm_img").show();

        var url = window.URL.createObjectURL(event.target.files[0]);
        document.getElementById("url").value = url;

        var evt = new CustomEvent("change");
        document.getElementById("url").dispatchEvent(evt);

        Emit.$emit("fileimg", event.target.files[0]);
      }
    },
  },
  mounted() {
    var summerHtmlImageMapCreator = (function () {
      "use strict";

      /* Utilities */
      var utils = {
        /**
         * Returns offset from html page top-left corner for some element
         *
         * @param node {HTMLElement} - html element
         * @returns {Object} - object with offsets, e.g. {x: 100, y: 200}
         */
        getOffset: function (node) {
          var boxCoords = node.getBoundingClientRect();

          return {
            x: Math.round(boxCoords.left + window.pageXOffset),
            y: Math.round(boxCoords.top + window.pageYOffset),
          };
        },

        /**
         * Returns correct coordinates (incl. offsets)
         *
         * @param x {number} - x-coordinate
         * @param y {number} - y-coordinate
         * @returns {Object} - object with recalculated coordinates, e.g. {x: 100, y: 200}
         */
        getRightCoords: function (x, y) {
          return {
            x: x - app.getOffset("x"),
            y: y - app.getOffset("y"),
          };
        },

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        id: function (str) {
          return document.getElementById(str);
        },

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        hide: function (node) {
          node.style.display = "none";

          return this;
        },

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        show: function (node) {
          node.style.display = "block";

          return this;
        },

        /**
         * Escape < and > (for code output)
         *
         * @param str {string} - a string with < and >
         * @returns {string} - a string with escaped < and >
         */
        encode: function (str) {
          return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        },

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        foreach: function (arr, func) {
          for (var i = 0, count = arr.length; i < count; i++) {
            func(arr[i], i);
          }
        },

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        foreachReverse: function (arr, func) {
          for (var i = arr.length - 1; i >= 0; i--) {
            func(arr[i], i);
          }
        },

        /**
         * Display debug info to some block
         */
        debug: (function () {
          var output = document.getElementById("debug");

          return function () {
            output.innerHTML = [].join.call(arguments, " ");
          };
        })(),

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        stopEvent: function (e) {
          e.stopPropagation();
          e.preventDefault();

          return this;
        },

        /**
         * TODO: will use same method of app.js
         * @deprecated
         */
        extend: function (obj, options) {
          var target = {};

          for (var name in obj) {
            if (obj.hasOwnProperty(name)) {
              target[name] = options[name] ? options[name] : obj[name];
            }
          }

          return target;
        },

        inherits: (function () {
          var F = function () {};

          return function (Child, Parent) {
            F.prototype = Parent.prototype;
            Child.prototype = new F();
            Child.prototype.constructor = Child;
          };
        })(),
      };

      /* Main module - will be main module in app.js-based application */
      var app = (function () {
        var domElements = {
            wrapper: utils.id("wrapper"),
            svg: utils.id("svg"),
            img: utils.id("img"),
            container: utils.id("image"),
            map: null,
          },
          state = {
            offset: {
              x: 0,
              y: 0,
            },
            appMode: null, // drawing || editing || preview
            currentType: null,
            editType: null,
            newArea: null,
            selectedArea: null,
            areas: [],
            events: [],
            isDraw: false,
            image: {
              src: null,
              filename: null,
              width: 0,
              height: 0,
            },
          },
          KEYS = {
            F1: 112,
            ESC: 27,
            TOP: 38,
            BOTTOM: 40,
            LEFT: 37,
            RIGHT: 39,
            DELETE: 46,
            I: 73,
            S: 83,
            C: 67,
          };

        function recalcOffsetValues() {
          state.offset = utils.getOffset(domElements.container);
        }

        /* Get offset value */
        window.addEventListener("resize", recalcOffsetValues, false);

        /* Disable selection */
        domElements.container.addEventListener(
          "mousedown",
          function (e) {
            e.preventDefault();
          },
          false
        );

        /* Disable image dragging */
        domElements.img.addEventListener(
          "dragstart",
          function (e) {
            e.preventDefault();
          },
          false
        );

        /* Display cursor coordinates info */
        var cursor_position_info = (function () {
          var coords_info = utils.id("coords");

          return {
            set: function (coords) {
              coords_info.innerHTML =
                "x: " + coords.x + ", " + "y: " + coords.y;
            },
            empty: function () {
              coords_info.innerHTML = "";
            },
          };
        })();

        domElements.container.addEventListener(
          "mousemove",
          function (e) {
            cursor_position_info.set(utils.getRightCoords(e.pageX, e.pageY));
          },
          false
        );

        domElements.container.addEventListener(
          "mouseleave",
          function () {
            cursor_position_info.empty();
          },
          false
        );

        /* Add mousedown event for svg */
        function onSvgMousedown(e) {
          if (state.appMode === "editing") {
            if (e.target.parentNode.tagName === "g") {
              info.unload();
              state.selectedArea = e.target.parentNode.obj;

              app.deselectAll();
              state.selectedArea.select();
              state.selectedArea.editingStartPoint = {
                x: e.pageX,
                y: e.pageY,
              };

              if (e.target.classList.contains("helper")) {
                var helper = e.target;
                state.editType = helper.action;

                if (helper.n >= 0) {
                  // if typeof selected_area == polygon
                  state.selectedArea.selected_point = helper.n;
                }

                app
                  .addEvent(
                    app.domElements.container,
                    "mousemove",
                    state.selectedArea.onProcessEditing.bind(state.selectedArea)
                  )
                  .addEvent(
                    app.domElements.container,
                    "mouseup",
                    state.selectedArea.onStopEditing.bind(state.selectedArea)
                  );
              } else if (
                e.target.tagName === "rect" ||
                e.target.tagName === "circle" ||
                e.target.tagName === "polygon"
              ) {
                state.editType = "move";

                app
                  .addEvent(
                    app.domElements.container,
                    "mousemove",
                    state.selectedArea.onProcessEditing.bind(state.selectedArea)
                  )
                  .addEvent(
                    app.domElements.container,
                    "mouseup",
                    state.selectedArea.onStopEditing.bind(state.selectedArea)
                  );
              }
            } else {
              app.deselectAll();
              info.unload();
            }
          }
        }

        domElements.container.addEventListener(
          "mousedown",
          onSvgMousedown,
          false
        );

        /* Add click event for svg */
        function onSvgClick(e) {
          if (
            state.appMode === "drawing" &&
            !state.isDraw &&
            state.currentType
          ) {
            code.hide();
            app.setIsDraw(true);

            state.newArea = Area.CONSTRUCTORS[
              state.currentType
            ].createAndStartDrawing(utils.getRightCoords(e.pageX, e.pageY));
          }
        }

        domElements.container.addEventListener("click", onSvgClick, false);

        /* Add dblclick event for svg */
        function onAreaDblClick(e) {
          if (state.appMode === "editing") {
            if (
              e.target.tagName === "rect" ||
              e.target.tagName === "circle" ||
              e.target.tagName === "polygon"
            ) {
              state.selectedArea = e.target.parentNode.obj;
              info.load(state.selectedArea, e.pageX, e.pageY);
            }
          }
        }

        domElements.container.addEventListener(
          "dblclick",
          onAreaDblClick,
          false
        );

        /* Add keydown event for document */
        function onDocumentKeyDown(e) {
          var ctrlDown = e.ctrlKey || e.metaKey; // PC || Mac

          switch (e.keyCode) {
            case KEYS.F1:
              help.show();
              e.preventDefault();

              break;

            case KEYS.ESC:
              help.hide();
              if (state.isDraw) {
                state.isDraw = false;
                state.newArea.remove();
                state.areas.pop();
                app.removeAllEvents();
              } else if (state.appMode === "editing") {
                state.selectedArea.redraw();
                app.removeAllEvents();
              }

              break;

            case KEYS.TOP:
              if (state.appMode === "editing" && state.selectedArea) {
                state.selectedArea.move(0, -1);
                e.preventDefault();
              }

              break;

            case KEYS.BOTTOM:
              if (state.appMode === "editing" && state.selectedArea) {
                state.selectedArea.move(0, 1);
                e.preventDefault();
              }
              break;

            case KEYS.LEFT:
              if (state.appMode === "editing" && state.selectedArea) {
                state.selectedArea.move(-1, 0);
                e.preventDefault();
              }

              break;

            case KEYS.RIGHT:
              if (state.appMode === "editing" && state.selectedArea) {
                state.selectedArea.move(1, 0);
                e.preventDefault();
              }

              break;

            case KEYS.DELETE:
              if (state.appMode === "editing" && state.selectedArea) {
                app.removeObject(state.selectedArea);
                state.selectedArea = null;
                info.unload();
              }

              break;

            case KEYS.I:
              if (state.appMode === "editing" && state.selectedArea) {
                var coordsForAttributesForm =
                  state.selectedArea.getCoordsForDisplayingInfo();

                info.load(
                  state.selectedArea,
                  coordsForAttributesForm.x + app.getOffset("x"),
                  coordsForAttributesForm.y + app.getOffset("y")
                );
              }

              break;

            case KEYS.S:
              if (ctrlDown) {
                app.saveInLocalStorage();
              }

              break;

            case KEYS.C:
              if (
                state.appMode === "editing" &&
                state.selectedArea &&
                ctrlDown
              ) {
                state.selectedArea = Area.copy(state.selectedArea);
              }

              break;
          }
        }

        document.addEventListener("keydown", onDocumentKeyDown, false);

        // Will moved from the main module
        var areasIO = {
          toJSON: function () {
            var obj = {
              areas: [],
              img: state.image.src,
            };

            utils.foreach(state.areas, function (x) {
              obj.areas.push(x.toJSON());
            });

            return JSON.stringify(obj);
          },
          fromJSON: function (str) {
            var obj = JSON.parse(str);

            app.loadImage(obj.img);

            utils.foreach(obj.areas, function (areaParams) {
              Area.fromJSON(areaParams);
            });
          },
        };

        // Will moved from the main module
        var localStorageWrapper = (function () {
          var KEY_NAME = "SummerHTMLImageMapCreator";

          return {
            save: function () {
              var result = areasIO.toJSON();
              window.localStorage.setItem(KEY_NAME, result);
              console.info("Editor " + result + " saved");

              alert("Saved");
            },
            restore: function () {
              areasIO.fromJSON(window.localStorage.getItem(KEY_NAME));
            },
          };
        })();

        return {
          domElements: domElements,
          saveInLocalStorage: localStorageWrapper.save,
          loadFromLocalStorage: localStorageWrapper.restore,
          hide: function () {
            utils.hide(domElements.container);
            return this;
          },
          show: function () {
            utils.show(domElements.container);
            return this;
          },
          recalcOffsetValues: function () {
            recalcOffsetValues();
            return this;
          },
          setDimensions: function (width, height) {
            domElements.svg.setAttribute("width", width);
            domElements.svg.setAttribute("height", height);
            domElements.container.style.width = width + "px";
            domElements.container.style.height = height + "px";
            return this;
          },
          loadImage: function (url) {
            get_image.showLoadIndicator();
            domElements.img.src = url;
            state.image.src = url;

            domElements.img.onload = function () {
              get_image.hideLoadIndicator().hide();
              app
                .show()
                .setDimensions(domElements.img.width, domElements.img.height)
                .recalcOffsetValues();
            };
            return this;
          },
          preview: (function () {
            domElements.img.setAttribute("usemap", "#map");
            domElements.map = document.createElement("map");
            domElements.map.setAttribute("name", "map");
            domElements.container.appendChild(domElements.map);

            return function () {
              info.unload();
              app.setShape(null);
              utils.hide(domElements.svg);
              domElements.map.innerHTML = app.getHTMLCode();
              code.print();
              return this;
            };
          })(),
          hidePreview: function () {
            utils.show(domElements.svg);
            domElements.map.innerHTML = "";
            return this;
          },
          addNodeToSvg: function (node) {
            domElements.svg.appendChild(node);
            return this;
          },
          removeNodeFromSvg: function (node) {
            domElements.svg.removeChild(node);
            return this;
          },
          getOffset: function (arg) {
            switch (arg) {
              case "x":
              case "y":
                return state.offset[arg];
            }
          },
          clear: function () {
            //remove all areas
            state.areas.length = 0;
            while (domElements.svg.childNodes[0]) {
              domElements.svg.removeChild(domElements.svg.childNodes[0]);
            }
            code.hide();
            info.unload();
            return this;
          },
          removeObject: function (obj) {
            utils.foreach(state.areas, function (x, i) {
              if (x === obj) {
                state.areas.splice(i, 1);
              }
            });
            obj.remove();
            return this;
          },
          deselectAll: function () {
            utils.foreach(state.areas, function (x) {
              x.deselect();
            });
            return this;
          },
          getIsDraw: function () {
            return state.isDraw;
          },
          setIsDraw: function (arg) {
            state.isDraw = arg;
            return this;
          },
          setMode: function (arg) {
            state.appMode = arg;
            return this;
          },
          getMode: function () {
            return state.appMode;
          },
          setShape: function (arg) {
            state.currentType = arg;
            return this;
          },
          getShape: function () {
            return state.currentType;
          },
          addObject: function (object) {
            state.areas.push(object);
            return this;
          },
          getNewArea: function () {
            return state.newArea;
          },
          resetNewArea: function () {
            state.newArea = null;
            return this;
          },
          getSelectedArea: function () {
            return state.selectedArea;
          },
          setSelectedArea: function (obj) {
            state.selectedArea = obj;
            return this;
          },
          getEditType: function () {
            return state.editType;
          },
          setFilename: function (str) {
            state.image.filename = str;
            return this;
          },
          setEditClass: function () {
            domElements.container.classList.remove("draw");
            domElements.container.classList.add("edit");

            return this;
          },
          setDrawClass: function () {
            domElements.container.classList.remove("edit");
            domElements.container.classList.add("draw");

            return this;
          },
          setDefaultClass: function () {
            domElements.container.classList.remove("edit");
            domElements.container.classList.remove("draw");

            return this;
          },
          addEvent: function (target, eventType, func) {
            state.events.push(new AppEvent(target, eventType, func));
            return this;
          },
          removeAllEvents: function () {
            utils.foreach(state.events, function (x) {
              x.remove();
            });
            state.events.length = 0;
            return this;
          },
          getHTMLCode: function (arg) {
            var html_code = "";
            if (arg) {
              if (!state.areas.length) {
                return "0 objects";
              }
              // html_code += utils.encode('<img src="' + state.image.filename + '" alt="" usemap="#map" />') +
              //     '<br />' + utils.encode('<map name="map">') + '<br />';
              html_code += utils.encode('<map name="map">') + "<br />";
              utils.foreachReverse(state.areas, function (x) {
                html_code +=
                  "&nbsp;&nbsp;&nbsp;&nbsp;" +
                  utils.encode(x.toHTMLMapElementString()) +
                  "<br />";
              });
              html_code += utils.encode("</map>");
            } else {
              utils.foreachReverse(state.areas, function (x) {
                html_code += x.toHTMLMapElementString();
              });
            }
            return html_code;
          },
        };
      })();

      /**
       * The constructor for dom events (for simple deleting of event)
       *
       * @constructor
       * @param {DOMElement} target - DOM-element
       * @param {String} eventType - e.g. 'click' or 'mousemove'
       * @param {Function} func - handler for this event
       */
      function AppEvent(target, eventType, func) {
        this.target = target;
        this.eventType = eventType;
        this.func = func;

        target.addEventListener(eventType, func, false);
      }

      /**
       * Remove this event listener from target
       */
      AppEvent.prototype.remove = function () {
        this.target.removeEventListener(this.eventType, this.func, false);
      };

      /**
       * The constructor of helpers points
       * Helper is small svg-rectangle with some actions
       *
       * @constructor
       * @param node {DOMElement} - a node for inserting helper
       * @param x {number} - x-coordinate of helper
       * @param y {number} - y-coordinate of helper
       * @param action {string} - an action by click of this helper (e.g. 'move')
       */
      function Helper(node, x, y, action) {
        this._el = document.createElementNS(Area.SVG_NS, "rect");

        this._el.classList.add(Helper.CLASS_NAME);
        this._el.setAttribute("height", Helper.SIZE);
        this._el.setAttribute("width", Helper.SIZE);
        this._el.setAttribute("x", x + Helper.OFFSET);
        this._el.setAttribute("y", y + Helper.OFFSET);

        node.appendChild(this._el);

        this._el.action = action; // TODO: move 'action' from dom el to data-attr
        this._el.classList.add(Helper.ACTIONS_TO_CURSORS[action]);
      }

      Helper.SIZE = 5;
      Helper.OFFSET = -Math.ceil(Helper.SIZE / 2);
      Helper.CLASS_NAME = "helper";
      Helper.ACTIONS_TO_CURSORS = {
        move: "move",
        editLeft: "e-resize",
        editRight: "w-resize",
        editTop: "n-resize",
        editBottom: "s-resize",
        editTopLeft: "nw-resize",
        editTopRight: "ne-resize",
        editBottomLeft: "sw-resize",
        editBottomRight: "se-resize",
        movePoint: "pointer",
      };

      /**
       * Set coordinates for this helper
       *
       * @param x {number} - x-coordinate
       * @param y {number} - y-coordinate
       * @returns {Helper}
       */
      Helper.prototype.setCoords = function (x, y) {
        this._el.setAttribute("x", x + Helper.OFFSET);
        this._el.setAttribute("y", y + Helper.OFFSET);

        return this;
      };

      /**
       * Set id of this helper in list of parent's helpers
       *
       * @param id {number}
       * @returns {Helper}
       */
      Helper.prototype.setId = function (id) {
        // TODO: move n-field from DOM-element to data-attribute
        this._el.n = id;

        return this;
      };

      /**
       * The abstract constructor for area
       *
       * @constructor
       * @abstract
       * @param type {string} - type of area ('rectangle', 'circle' or 'polygon')
       * @param coords {Object} - coordinates of area (e.g. x, y, width, height)
       * @param attributes {Object} [attributes=undefined] - attributes for area (e.g. href, title)
       */
      function Area(type, coords, attributes) {
        if (this.constructor === Area) {
          throw new Error("This is abstract class");
        }

        this._type = type;

        /**
         * @namespace
         * @property href {string} - href-attribute of area
         * @property alt {string} - alt-attribute of area
         * @property title {string} - title-attribute of area
         */
        this._attributes = {
          href: "",
          alt: "",
          title: "",
        };

        if (attributes) {
          this.setInfoAttributes(attributes);
        }

        this._coords = coords;

        // the g-element, it contains this area and helpers elements
        this._groupEl = document.createElementNS(Area.SVG_NS, "g");
        app.addNodeToSvg(this._groupEl);

        // TODO: remove this field from DOM-element
        // Link to parent object
        this._groupEl.obj = this;

        // svg-dom-element of area
        this._el = null;

        // Object with all helpers of area
        this._helpers = {};

        // Add this new area to list of all areas
        app.addObject(this);
      }
      Area.SVG_NS = "http://www.w3.org/2000/svg"; // TODO: move to main editor constructor
      Area.CLASS_NAMES = {
        SELECTED: "selected",
        WITH_HREF: "with_href",
      };
      Area.CONSTRUCTORS = {
        rectangle: Rectangle,
        circle: Circle,
        polygon: Polygon,
      };

      var URL = "/mis-eventos/puestos_localidad/";

      Area.REGEXP = {
        AREA: /<area(?=.*? shape="(rect|circle|poly)")(?=.*? coords="([\d ,]+?)")[\s\S]*?>/gim,
        HREF: / href="([\S\s]+?)"/,
        ALT: / alt="([\S\s]+?)"/,
        TITLE: / title="([\S\s]+?)"/,
        DELIMETER: / ?, ?/,
      };
      Area.HTML_NAMES_TO_AREA_NAMES = {
        rect: "rectangle",
        circle: "circle",
        poly: "polygon",
      };
      Area.ATTRIBUTES_NAMES = ["HREF", "ALT", "TITLE"];

      /**
       * This method should be implemented for child-classes
       *
       * @throws {AbstractMethodCall}
       */
      Area.prototype.ABSTRACT_METHOD = function () {
        throw new Error("This is abstract method");
      };

      /**
       * All these methods are abstract
       *
       * @throws {AbstractMethodCall}
       */
      Area.prototype.setSVGCoords =
        Area.prototype.setCoords =
        Area.prototype.dynamicDraw =
        Area.prototype.onProcessDrawing =
        Area.prototype.onStopDrawing =
        Area.prototype.edit =
        Area.prototype.dynamicEdit =
        Area.prototype.onProcessEditing =
        Area.prototype.onStopEditing =
        Area.prototype.toString =
        Area.prototype.toHTMLMapElementString =
        Area.prototype.getCoordsForDisplayingInfo =
          Area.prototype.ABSTRACT_METHOD;

      /**
       * Redraw this area with own or custom coordinates
       *
       * @param coords {Object} [coords=undefined]
       * @returns {Area} - this area
       */
      Area.prototype.redraw = function (coords) {
        this.setSVGCoords(coords ? coords : this._coords);

        return this;
      };

      /**
       * Remove this area from DOM-tree
       */
      Area.prototype.remove = function () {
        app.removeNodeFromSvg(this._groupEl);
      };

      /**
       * Move this area by dx, dy
       *
       * @returns {Area} - this area
       */
      Area.prototype.move = function (dx, dy) {
        this.setCoords(this.edit("move", dx, dy)).redraw();
        return this;
      };

      /**
       * Add class name for selected areas to this area
       *
       * @returns {Area} - this area
       */
      Area.prototype.select = function () {
        this._el.classList.add(Area.CLASS_NAMES.SELECTED);
        console.info(this.toString() + " is selected now");

        return this;
      };

      /**
       * Remove class name for selected areas from this area
       *
       * @returns {Area} - this area
       */
      Area.prototype.deselect = function () {
        this._el.classList.remove(Area.CLASS_NAMES.SELECTED);

        return this;
      };

      /**
       * Set style of element with href attribute for this area
       *
       * @returns {Area} - this area
       */
      Area.prototype.setStyleOfElementWithHref = function () {
        this._el.classList.add(Area.CLASS_NAMES.WITH_HREF);

        return this;
      };

      /**
       * Unset style of element with href attribute for this area
       *
       * @returns {Area} - this area
       */
      Area.prototype.unsetStyleOfElementWithHref = function () {
        this._el.classList.remove(Area.CLASS_NAMES.WITH_HREF);

        return this;
      };

      /**
       * Set attributes (href, alt and title) for this area
       *
       * @param attributes {Object} - Object with attributes for area
       */
      Area.prototype.setInfoAttributes = function (attributes) {
        this._attributes.href =
          "/mis-eventos/puestos_localidad/" + attributes.href;
        this._attributes.alt = attributes.alt;
        this._attributes.title = attributes.title;
      };

      /**
       * Returns json-representation of this area
       *
       * @returns {Object}
       */
      Area.prototype.toJSON = function () {
        /**
         * @namespace
         * @property type {string} - type of this area (e.g. 'rectangle', 'circle')
         * @property coords {Object} - coordinates of this area (e.g. 'x', 'width')
         * @property attributes {Object} - attributes of this area (e.g. 'href', 'title')
         */
        return {
          type: this._type,
          coords: this._coords,
          attributes: this._attributes,
        };
      };

      /**
       * Returns new area object created with params from json-object
       *
       * @static
       * @param params {Object} - params of area, incl. type, coords and attributes
       * @returns {Rectangle|Circle|Polygon}
       */
      Area.fromJSON = function (params) {
        var AreaConstructor = Area.CONSTRUCTORS[params.type];

        if (!AreaConstructor) {
          throw new Error("This area type is not valid");
        }

        if (!AreaConstructor.testCoords(params.coords)) {
          throw new Error("This coords is not valid for " + params.type);
        }

        app.setIsDraw(true);

        var area = new AreaConstructor(params.coords, params.attributes);

        app.setIsDraw(false).resetNewArea();

        return area;
      };

      /**
       * Creates new areas from html-string with <area /> elements
       *
       * @param htmlStr {string}
       * @returns {Array} - array with areas
       */
      Area.createAreasFromHTMLOfMap = function (htmlStr) {
        if (!htmlStr) {
          return false;
        }

        while (true) {
          var findedResult = Area.REGEXP.AREA.exec(htmlStr); // <area target="_blank" class="maparea" shape="$1" coords="$2" ... />
          if (!findedResult) {
            break;
          }

          var htmlAreaFinded = findedResult[0], // <area target="_blank" class="maparea" shape="..." coords="..." ... />
            type = findedResult[1], // $1
            coords = findedResult[2].split(Area.REGEXP.DELIMETER), // $2
            attributes = {};

          Area.ATTRIBUTES_NAMES.forEach(function (item, i) {
            var result = Area.REGEXP[item].exec(htmlAreaFinded);

            if (result) {
              attributes[name] = result[1];
            }
          });

          coords = coords.map(function (item) {
            return Number(item);
          });

          type = Area.HTML_NAMES_TO_AREA_NAMES[type];

          Area.fromJSON({
            type: type,
            coords: Area.CONSTRUCTORS[type].getCoordsFromHTMLArray(coords),
            attributes: attributes,
          });
        }

        return Boolean(htmlAreaFinded);
      };

      /**
       * Returns copy of original area, selected and moved by (10,10) from it
       *
       * @param originalArea {Area}
       * @returns {Area} - a copy of original area
       */
      Area.copy = function (originalArea) {
        return Area.fromJSON(originalArea.toJSON()).move(10, 10).select();
      };

      /* ---------- Constructors for real areas ---------- */

      /**
       * The constructor for rectangles
       *
       * (x, y) -----
       * |          | height
       * ------------
       *     width
       *
       * @constructor
       * @param coords {Object} - object with parameters of new area (x, y, width, height)
       *                          if some parameter is undefined, it will set 0
       * @param attributes {Object} [attributes=undefined] - attributes for area (e.g. href, title)
       */
      function Rectangle(coords, attributes) {
        Area.call(this, "rectangle", coords, attributes);

        /**
         * @namespace
         * @property {number} x - Distance from the left edge of the image to the left side of the rectangle
         * @property {number} y - Distance from the top edge of the image to the top side of the rectangle
         * @property {number} width - Width of rectangle
         * @property {number} height - Height of rectangle
         */
        this._coords = {
          x: coords.x || 0,
          y: coords.y || 0,
          width: coords.width || 0,
          height: coords.height || 0,
        };

        this._el = document.createElementNS(Area.SVG_NS, "rect");
        this._groupEl.appendChild(this._el);

        var x = coords.x - this._coords.width / 2,
          y = coords.y - this._coords.height / 2;

        this._helpers = {
          center: new Helper(this._groupEl, x, y, "move"),
          top: new Helper(this._groupEl, x, y, "editTop"),
          bottom: new Helper(this._groupEl, x, y, "editBottom"),
          left: new Helper(this._groupEl, x, y, "editLeft"),
          right: new Helper(this._groupEl, x, y, "editRight"),
          topLeft: new Helper(this._groupEl, x, y, "editTopLeft"),
          topRight: new Helper(this._groupEl, x, y, "editTopRight"),
          bottomLeft: new Helper(this._groupEl, x, y, "editBottomLeft"),
          bottomRight: new Helper(this._groupEl, x, y, "editBottomRight"),
        };

        this.redraw();
      }
      utils.inherits(Rectangle, Area);

      /**
       * Set attributes for svg-elements of area by new parameters
       *
       * -----top------
       * |            |
       * ---center_y---
       * |            |
       * ----bottom----
       *
       * @param coords {Object} - Object with coords of this area (x, y, width, height)
       * @returns {Rectangle} - this rectangle
       */
      Rectangle.prototype.setSVGCoords = function (coords) {
        this._el.setAttribute("x", coords.x);
        this._el.setAttribute("y", coords.y);
        this._el.setAttribute("width", coords.width);
        this._el.setAttribute("height", coords.height);

        var top = coords.y,
          center_y = coords.y + coords.height / 2,
          bottom = coords.y + coords.height,
          left = coords.x,
          center_x = coords.x + coords.width / 2,
          right = coords.x + coords.width;

        this._helpers.center.setCoords(center_x, center_y);
        this._helpers.top.setCoords(center_x, top);
        this._helpers.bottom.setCoords(center_x, bottom);
        this._helpers.left.setCoords(left, center_y);
        this._helpers.right.setCoords(right, center_y);
        this._helpers.topLeft.setCoords(left, top);
        this._helpers.topRight.setCoords(right, top);
        this._helpers.bottomLeft.setCoords(left, bottom);
        this._helpers.bottomRight.setCoords(right, bottom);

        return this;
      };

      /**
       * Set coords for this area
       *
       * @param coords {coords}
       * @returns {Rectangle} - this rectangle
       */
      Rectangle.prototype.setCoords = function (coords) {
        this._coords.x = coords.x;
        this._coords.y = coords.y;
        this._coords.width = coords.width;
        this._coords.height = coords.height;

        return this;
      };

      /**
       * Calculates new coordinates in process of drawing
       *
       * @param x {number} - x-coordinate of cursor
       * @param y {number} - y-coordinate of cursor
       * @param isSquare {boolean}
       * @returns {Object} - calculated coords of this area
       */
      Rectangle.prototype.dynamicDraw = function (x, y, isSquare) {
        var newCoords = {
          x: this._coords.x,
          y: this._coords.y,
          width: x - this._coords.x,
          height: y - this._coords.y,
        };

        if (isSquare) {
          newCoords = Rectangle.getSquareCoords(newCoords);
        }

        newCoords = Rectangle.getNormalizedCoords(newCoords);

        this.redraw(newCoords);

        return newCoords;
      };

      /**
       * Handler for drawing process (by mousemove)
       * It includes only redrawing area by new coords
       * (this coords doesn't save as own area coords)
       *
       * @params e {MouseEvent} - mousemove event
       */
      Rectangle.prototype.onProcessDrawing = function (e) {
        var coords = utils.getRightCoords(e.pageX, e.pageY);

        this.dynamicDraw(coords.x, coords.y, e.shiftKey);
      };

      /**
       * Handler for drawing stoping (by second click on drawing canvas)
       * It includes redrawing area by new coords
       * and saving this coords as own area coords
       *
       * @params e {MouseEvent} - click event
       */
      Rectangle.prototype.onStopDrawing = function (e) {
        var coords = utils.getRightCoords(e.pageX, e.pageY);

        this.setCoords(
          this.dynamicDraw(coords.x, coords.y, e.shiftKey)
        ).deselect();

        app.removeAllEvents().setIsDraw(false).resetNewArea();
      };

      /**
       * Changes area parameters by editing type and offsets
       *
       * @param {string} editingType - A type of editing (e.g. 'move')
       * @returns {Object} - Object with changed parameters of area
       */
      Rectangle.prototype.edit = function (editingType, dx, dy) {
        var tempParams = Object.create(this._coords);

        switch (editingType) {
          case "move":
            tempParams.x += dx;
            tempParams.y += dy;
            break;

          case "editLeft":
            tempParams.x += dx;
            tempParams.width -= dx;
            break;

          case "editRight":
            tempParams.width += dx;
            break;

          case "editTop":
            tempParams.y += dy;
            tempParams.height -= dy;
            break;

          case "editBottom":
            tempParams.height += dy;
            break;

          case "editTopLeft":
            tempParams.x += dx;
            tempParams.y += dy;
            tempParams.width -= dx;
            tempParams.height -= dy;
            break;

          case "editTopRight":
            tempParams.y += dy;
            tempParams.width += dx;
            tempParams.height -= dy;
            break;

          case "editBottomLeft":
            tempParams.x += dx;
            tempParams.width -= dx;
            tempParams.height += dy;
            break;

          case "editBottomRight":
            tempParams.width += dx;
            tempParams.height += dy;
            break;
        }

        return tempParams;
      };

      /**
       * Calculates new coordinates in process of editing
       *
       * @param coords {Object} - area coords
       * @param saveProportions {boolean}
       * @returns {Object} - new coordinates of area
       */
      Rectangle.prototype.dynamicEdit = function (coords, saveProportions) {
        coords = Rectangle.getNormalizedCoords(coords);

        if (saveProportions) {
          coords = Rectangle.getSavedProportionsCoords(coords);
        }

        this.redraw(coords);

        return coords;
      };

      /**
       * Handler for editing process (by mousemove)
       * It includes only redrawing area by new coords
       * (this coords doesn't save as own area coords)
       *
       * @params e {MouseEvent} - mousemove event
       */
      Rectangle.prototype.onProcessEditing = function (e) {
        return this.dynamicEdit(
          this.edit(
            app.getEditType(),
            e.pageX - this.editingStartPoint.x,
            e.pageY - this.editingStartPoint.y
          ),
          e.shiftKey
        );
      };

      /**
       * Handler for editing stoping (by mouseup)
       * It includes redrawing area by new coords
       * and saving this coords as own area coords
       *
       * @params e {MouseEvent} - mouseup event
       */
      Rectangle.prototype.onStopEditing = function (e) {
        this.setCoords(this.onProcessEditing(e));
        app.removeAllEvents();
      };

      /**
       * Returns string-representation of this rectangle
       *
       * @returns {string}
       */
      Rectangle.prototype.toString = function () {
        return (
          "Rectangle {x: " +
          this._coords.x +
          ", y: " +
          this._coords.y +
          ", width: " +
          this._coords.width +
          ", height: " +
          this._coords.height +
          "}"
        );
      };

      /**
       * Returns html-string of area html element with params of this rectangle
       *
       * @returns {string}
       */
      Rectangle.prototype.toHTMLMapElementString = function () {
        var x2 = this._coords.x + this._coords.width,
          y2 = this._coords.y + this._coords.height;

        return (
          '<area target="_blank" class="maparea" shape="rect" coords="' + // TODO: use template engine
          this._coords.x +
          ", " +
          this._coords.y +
          ", " +
          x2 +
          ", " +
          y2 +
          '"' +
          (this._attributes.href
            ? ' href="' + this._attributes.href + '"'
            : "") +
          (this._attributes.alt ? ' alt="' + this._attributes.alt + '"' : "") +
          (this._attributes.title
            ? ' title="' + this._attributes.title + '"'
            : "") +
          " />"
        );
      };

      /**
       * Returns coords for area attributes form
       *
       * @returns {Object} - object width coordinates of point
       */
      Rectangle.prototype.getCoordsForDisplayingInfo = function () {
        return {
          x: this._coords.x,
          y: this._coords.y,
        };
      };

      /**
       * Returns true if coords is valid for rectangles and false otherwise
       *
       * @static
       * @param coords {Object} - object with coords for new rectangle
       * @return {boolean}
       */
      Rectangle.testCoords = function (coords) {
        return coords.x && coords.y && coords.width && coords.height;
      };

      /**
       * Returns true if html coords array is valid for rectangles and false otherwise
       *
       * @static
       * @param coords {Array} - coords for new rectangle as array
       * @return {boolean}
       */
      Rectangle.testHTMLCoords = function (coords) {
        return coords.length === 4;
      };

      /**
       * Return rectangle coords object from html array
       *
       * @param htmlCoordsArray {Array}
       * @returns {Object}
       */
      Rectangle.getCoordsFromHTMLArray = function (htmlCoordsArray) {
        if (!Rectangle.testHTMLCoords(htmlCoordsArray)) {
          throw new Error("This html-coordinates is not valid for rectangle");
        }

        return {
          x: htmlCoordsArray[0],
          y: htmlCoordsArray[1],
          width: htmlCoordsArray[2] - htmlCoordsArray[0],
          height: htmlCoordsArray[3] - htmlCoordsArray[1],
        };
      };

      /**
       * Fixes coords if width or/and height are negative
       *
       * @static
       * @param coords {Object} - Coordinates of this area
       * @returns {Object} - Normalized coordinates of area
       */
      Rectangle.getNormalizedCoords = function (coords) {
        if (coords.width < 0) {
          coords.x += coords.width;
          coords.width = Math.abs(coords.width);
        }

        if (coords.height < 0) {
          coords.y += coords.height;
          coords.height = Math.abs(coords.height);
        }

        return coords;
      };

      /**
       * Returns coords with equivivalent width and height
       *
       * @static
       * @param coords {Object} - Coordinates of this area
       * @returns {Object} - Coordinates of area with equivivalent width and height
       */
      Rectangle.getSquareCoords = function (coords) {
        var width = Math.abs(coords.width),
          height = Math.abs(coords.height);

        if (width > height) {
          coords.width = coords.width > 0 ? height : -height;
        } else {
          coords.height = coords.height > 0 ? width : -width;
        }

        return coords;
      };

      /**
       * Returns coords with saved proportions of original area
       *
       * @static
       * @param coords {Object} - Coordinates of this area
       * @param originalCoords {Object} - Coordinates of the original area
       * @returns {Object} - Coordinates of area with saved proportions of original area
       */
      Rectangle.getSavedProportionsCoords = function (coords, originalCoords) {
        var originalProportions = coords.width / coords.height,
          currentProportions = originalCoords.width / originalCoords.height;

        if (currentProportions > originalProportions) {
          coords.width = Math.round(coords.height * originalProportions);
        } else {
          coords.height = Math.round(coords.width / originalProportions);
        }

        return coords;
      };

      /**
       * Creates new rectangle and adds drawing handlers for DOM-elements
       *
       * @static
       * @param firstPointCoords {Object}
       * @returns {Rectangle}
       */
      Rectangle.createAndStartDrawing = function (firstPointCoords) {
        var newArea = new Rectangle({
          x: firstPointCoords.x,
          y: firstPointCoords.y,
          width: 0,
          height: 0,
        });

        app
          .addEvent(
            app.domElements.container,
            "mousemove",
            newArea.onProcessDrawing.bind(newArea)
          )
          .addEvent(
            app.domElements.container,
            "click",
            newArea.onStopDrawing.bind(newArea)
          );

        return newArea;
      };

      /**
       * The constructor for circles
       *
       *     ------
       *  /         \
       * |  (x, y)<->| radius
       *  \         /
       *    ------
       *
       * @constructor
       * @param coords {Object} - object with parameters of new area (cx, cy, radius)
       *                          if some parameter is undefined, it will set 0
       * @param attributes {Object} [attributes=undefined] - attributes for area (e.g. href, title)
       */
      function Circle(coords, attributes) {
        Area.call(this, "circle", coords, attributes);

        /**
         * @namespace
         * @property {number} cx - Distance from the left edge of the image to the center of the circle
         * @property {number} cy - Distance from the top edge of the image to the center of the circle
         * @property {number} radius - Radius of the circle
         */
        this._coords = {
          cx: coords.cx || 0,
          cy: coords.cy || 0,
          radius: coords.radius || 0,
        };

        this._el = document.createElementNS(Area.SVG_NS, "circle");
        this._groupEl.appendChild(this._el);

        this.helpers = {
          center: new Helper(this._groupEl, coords.cx, coords.cy, "move"),
          top: new Helper(this._groupEl, coords.cx, coords.cy, "editTop"),
          bottom: new Helper(this._groupEl, coords.cx, coords.cy, "editBottom"),
          left: new Helper(this._groupEl, coords.cx, coords.cy, "editLeft"),
          right: new Helper(this._groupEl, coords.cx, coords.cy, "editRight"),
        };

        this.redraw();
      }
      utils.inherits(Circle, Area);

      /**
       * Set attributes for svg-elements of area by new parameters
       *
       * @param coords {Object} - Object with coords of this area (cx, cy, radius)
       * @returns {Circle} - this area
       */
      Circle.prototype.setSVGCoords = function (coords) {
        this._el.setAttribute("cx", coords.cx);
        this._el.setAttribute("cy", coords.cy);
        this._el.setAttribute("r", coords.radius);

        this.helpers.center.setCoords(coords.cx, coords.cy);
        this.helpers.top.setCoords(coords.cx, coords.cy - coords.radius);
        this.helpers.right.setCoords(coords.cx + coords.radius, coords.cy);
        this.helpers.bottom.setCoords(coords.cx, coords.cy + coords.radius);
        this.helpers.left.setCoords(coords.cx - coords.radius, coords.cy);

        return this;
      };

      /**
       * Set coords for this area
       *
       * @param coords {Object} - coordinates for thia area
       * @returns {Circle} - this area
       */
      Circle.prototype.setCoords = function (coords) {
        this._coords.cx = coords.cx;
        this._coords.cy = coords.cy;
        this._coords.radius = coords.radius;

        return this;
      };

      /**
       * Calculates new coordinates in process of drawing
       * (for circle normalizeCoords() don't needed because
       * radius are always positive)
       *
       * @param x {number} - x-coordinate
       * @param y {number} - y-coordinate
       * @returns {Object} - calculated coordinates
       */
      Circle.prototype.dynamicDraw = function (x, y) {
        var radius = Math.round(
            Math.sqrt(
              Math.pow(this._coords.cx - x, 2) +
                Math.pow(this._coords.cy - y, 2)
            )
          ),
          newCoords = {
            cx: this._coords.cx,
            cy: this._coords.cy,
            radius: radius,
          };

        this.redraw(newCoords);

        return newCoords;
      };

      /**
       * Handler for drawing process (by mousemove)
       * It includes only redrawing area by new coords
       * (this coords doesn't save as own area coords)
       *
       * @params e {MouseEvent} - mousemove event
       */
      Circle.prototype.onProcessDrawing = function (e) {
        var coords = utils.getRightCoords(e.pageX, e.pageY);

        this.dynamicDraw(coords.x, coords.y);
      };

      /**
       * Handler for drawing stoping (by second click)
       * It includes redrawing area by new coords
       * and saving this coords as own area coords
       *
       * @params e {MouseEvent} - click event
       */
      Circle.prototype.onStopDrawing = function (e) {
        var coords = utils.getRightCoords(e.pageX, e.pageY);

        this.setCoords(this.dynamicDraw(coords.x, coords.y)).deselect();

        app.removeAllEvents().setIsDraw(false).resetNewArea();
      };

      /**
       * Changes area parameters by editing type and offsets
       *
       * @param {string} editingType - A type of editing
       * @returns {Object} - Object with changed parameters of area
       */
      Circle.prototype.edit = function (editingType, dx, dy) {
        var tempParams = Object.create(this._coords);

        switch (editingType) {
          case "move":
            tempParams.cx += dx;
            tempParams.cy += dy;
            break;

          case "editTop":
            tempParams.radius -= dy;
            break;

          case "editBottom":
            tempParams.radius += dy;
            break;

          case "editLeft":
            tempParams.radius -= dx;
            break;

          case "editRight":
            tempParams.radius += dx;
            break;
        }

        return tempParams;
      };

      /**
       * Calculates new coordinates in process of editing
       *
       * @param tempCoords {Object} - area coords
       * @returns {Object} - calculated coordinates
       */
      Circle.prototype.dynamicEdit = function (tempCoords) {
        if (tempCoords.radius < 0) {
          tempCoords.radius = Math.abs(tempCoords.radius);
        }

        this.setSVGCoords(tempCoords);

        return tempCoords;
      };

      /**
       * Handler for editing process (by mousemove)
       * It includes only redrawing area by new coords
       * (this coords doesn't save as own area coords)
       *
       * @params e {MouseEvent} - mousemove event
       */
      Circle.prototype.onProcessEditing = function (e) {
        var editType = app.getEditType();

        return this.dynamicEdit(
          this.edit(
            editType,
            e.pageX - this.editingStartPoint.x,
            e.pageY - this.editingStartPoint.y
          )
        );
      };

      /**
       * Handler for editing stoping (by mouseup)
       * It includes redrawing area by new coords
       * and saving this coords as own area coords
       *
       * @params e {MouseEvent} - mouseup event
       */
      Circle.prototype.onStopEditing = function (e) {
        var editType = app.getEditType();

        this.setCoords(this.onProcessEditing(e));

        app.removeAllEvents();
      };

      /**
       * Returns string-representation of circle
       *
       * @returns {string}
       */
      Circle.prototype.toString = function () {
        return (
          "Circle {cx: " +
          this._coords.cx +
          ", cy: " +
          this._coords.cy +
          ", radius: " +
          this._coords.radius +
          "}"
        );
      };

      /**
       * Returns html-string of area html element with params of this circle
       *
       * @returns {string}
       */
      Circle.prototype.toHTMLMapElementString = function () {
        return (
          '<area target="_blank" class="maparea" shape="circle" coords="' +
          this._coords.cx +
          ", " +
          this._coords.cy +
          ", " +
          this._coords.radius +
          '"' +
          (this._attributes.href
            ? ' href="' + this._attributes.href + '"'
            : "") +
          (this._attributes.alt ? ' alt="' + this._attributes.alt + '"' : "") +
          (this._attributes.title
            ? ' title="' + this._attributes.title + '"'
            : "") +
          " />"
        );
      };

      /**
       * Returns coords for area attributes form
       *
       * @returns {Object} - coordinates of point
       */
      Circle.prototype.getCoordsForDisplayingInfo = function () {
        return {
          x: this._coords.cx,
          y: this._coords.cy,
        };
      };

      /**
       * Returns true if coords is valid for circles and false otherwise
       *
       * @static
       * @param coords {Object} - object width coords for new circle
       * @return {boolean}
       */
      Circle.testCoords = function (coords) {
        return coords.cx && coords.cy && coords.radius;
      };

      /**
       * Returns true if html coords array is valid for circles and false otherwise
       *
       * @static
       * @param coords {Array} - coords for new circle as array
       * @return {boolean}
       */
      Circle.testHTMLCoords = function (coords) {
        return coords.length === 3;
      };

      /**
       * Returns circle coords object from html array
       *
       * @param htmlCoordsArray {Array}
       * @returns {Object}
       */
      Circle.getCoordsFromHTMLArray = function (htmlCoordsArray) {
        if (!Circle.testHTMLCoords(htmlCoordsArray)) {
          throw new Error("This html-coordinates is not valid for circle");
        }

        return {
          cx: htmlCoordsArray[0],
          cy: htmlCoordsArray[1],
          radius: htmlCoordsArray[2],
        };
      };

      /**
       * Creates new circle and adds drawing handlers for DOM-elements
       *
       * @static
       * @param firstPointCoords {Object}
       * @returns {Circle}
       */
      Circle.createAndStartDrawing = function (firstPointCoords) {
        var newArea = new Circle({
          cx: firstPointCoords.x,
          cy: firstPointCoords.y,
          radius: 0,
        });

        app
          .addEvent(
            app.domElements.container,
            "mousemove",
            newArea.onProcessDrawing.bind(newArea)
          )
          .addEvent(
            app.domElements.container,
            "click",
            newArea.onStopDrawing.bind(newArea)
          );

        return newArea;
      };

      /**
       * The constructor for polygons
       *
       *        {x0, y0}
       *           /\
       *          /  \
       *         /    \
       * {x1, y1} ----- {x2, y2}
       *
       * @constructor
       * @param coords {Object} - object with parameters of new area ('points' is list of points)
       *                          if 'points' is empty, it will set to [(0,0)]
       * @param coords.isOpened {boolean} - if polygon is opened (polyline instead polygon)
       * @param attributes {Object} [attributes=undefined] - attributes for area (e.g. href, title)
       */
      function Polygon(coords, attributes) {
        Area.call(this, "polygon", coords, attributes);

        /**
         * @namespace
         * @property {Array} points - Array with coordinates of polygon points
         */
        this._coords = {
          points: coords.points || [{ x: 0, y: 0 }],
          isOpened: coords.isOpened || false,
        };

        this._el = document.createElementNS(
          Area.SVG_NS,
          this._coords.isOpened ? "polyline" : "polygon"
        );
        this._groupEl.appendChild(this._el);

        this._helpers = {
          points: [],
        };

        for (var i = 0, c = this._coords.points.length; i < c; i++) {
          this._helpers.points.push(
            new Helper(
              this._groupEl,
              this._coords.points[i].x,
              this._coords.points[i].y,
              "movePoint"
            ).setId(i)
          );
        }

        this._selectedPoint = -1;

        this.redraw();
      }
      utils.inherits(Polygon, Area);

      /**
       * Closes path of the polygon (replaces polyline with polygon)
       */
      Polygon.prototype.close = function () {
        var polyline = this._el;
        this._el = document.createElementNS(Area.SVG_NS, "polygon");
        this._groupEl.replaceChild(this._el, polyline);

        this._coords.isOpened = false;
        this.redraw().deselect();
      };

      /**
       * Set attributes for svg-elements of area by new parameters
       *
       * @param coords {Object} - Object with coords of this area, with field 'points'
       * @returns {Polygon} - this area
       */
      Polygon.prototype.setSVGCoords = function (coords) {
        var polygonPointsAttrValue = coords.points.reduce(function (
          previousValue,
          currentItem
        ) {
          return previousValue + currentItem.x + " " + currentItem.y + " ";
        },
        "");

        this._el.setAttribute("points", polygonPointsAttrValue);
        utils.foreach(this._helpers.points, function (helper, i) {
          helper.setCoords(coords.points[i].x, coords.points[i].y);
        });

        return this;
      };

      /**
       * Set coords for this area
       *
       * @param coords {coords}
       * @returns {Polygon} - this area
       */
      Polygon.prototype.setCoords = function (coords) {
        this._coords.points = coords.points;

        return this;
      };

      /**
       * Adds new point to polygon (and new helper too)
       *
       * @param x {number} - x-coordinate of new point
       * @param y {number} - y-coordinate of new point
       * @returns {Polygon} - this area
       */
      Polygon.prototype.addPoint = function (x, y) {
        if (!this._coords.isOpened) {
          throw new Error("This polygon is closed!");
        }

        var helper = new Helper(this._groupEl, x, y, "movePoint");
        helper.setId(this._helpers.points.length);

        this._helpers.points.push(helper);
        this._coords.points.push({
          x: x,
          y: y,
        });
        this.redraw();

        return this;
      };

      /**
       * Calculates new coordinates in process of drawing
       *
       * @param x {number}
       * @param y {number}
       * @param isRightAngle {boolean}
       * @returns {Object} - calculated coordinates
       */
      Polygon.prototype.dynamicDraw = function (x, y, isRightAngle) {
        var temp_coords = {
          points: [].concat(this._coords.points),
        };

        if (isRightAngle) {
          var rightPointCoords = Polygon.getRightAngleLineLastPointCoords(
            this._coords,
            { x: x, y: y }
          );
          x = rightPointCoords.x;
          y = rightPointCoords.y;
        }

        temp_coords.points.push({ x: x, y: y });

        this.redraw(temp_coords);

        return temp_coords;
      };

      /**
       * Handler for drawing process (by mousemove)
       * It includes only redrawing area by new coords
       * (this coordinates doesn't save as own area coords)
       *
       * @params e {MouseEvent} - mousemove event
       */
      Polygon.prototype.onProcessDrawing = function (e) {
        var coords = utils.getRightCoords(e.pageX, e.pageY);

        this.dynamicDraw(coords.x, coords.y, e.shiftKey);
      };

      /**
       * Handler for polygon pointer adding (by click on drawing canvas)
       * It includes redrawing area with this new point
       * and saving this point to list of polygon points
       *
       * @params e {MouseEvent} - click event
       */
      Polygon.prototype.onAddPointDrawing = function (e) {
        var newPointCoords = utils.getRightCoords(e.pageX, e.pageY);

        if (e.shiftKey) {
          newPointCoords = Polygon.getRightAngleLineLastPointCoords(
            this._coords,
            newPointCoords
          );
        }

        this.addPoint(newPointCoords.x, newPointCoords.y);
      };

      /**
       * Handler for drawing stoping (by click on first helper or press ENTER key)
       * It includes redrawing area by new coords, closing this polygon
       * and saving this coords as own area coords
       *
       * @params e {KeyboardEvent|MouseEvent} - click or keydown event
       */
      Polygon.prototype.onStopDrawing = function (e) {
        if (e.type == "click" || (e.type == "keydown" && e.keyCode == 13)) {
          if (Polygon.testCoords(this._coords)) {
            this.close();

            app.removeAllEvents().setIsDraw(false).resetNewArea();
          }
        }
        e.stopPropagation();
      };

      /**
       * Changes area parameters by editing type and offsets
       *
       * @param {string} editingType - A type of editing
       * @returns {Object} - Object with changed parameters of area
       */
      Polygon.prototype.edit = function (editingType, dx, dy) {
        var tempParams = Object.create(this._coords);

        switch (editingType) {
          case "move":
            for (var i = 0, c = tempParams.points.length; i < c; i++) {
              tempParams.points[i].x += dx;
              tempParams.points[i].y += dy;
            }
            break;

          case "movePoint":
            tempParams.points[this.selected_point].x += dx;
            tempParams.points[this.selected_point].y += dy;
            break;
        }

        return tempParams;
      };

      /**
       * Handler for editing process (by mousemove)
       * It includes only redrawing area by new coords
       * (this coords doesn't save as area coords)
       *
       * @params e {MouseEvent} - mousemove event
       */
      Polygon.prototype.onProcessEditing = function (e) {
        var editType = app.getEditType();

        this.redraw(
          this.edit(
            editType,
            e.pageX - this.editingStartPoint.x,
            e.pageY - this.editingStartPoint.y
          )
        );

        this.editingStartPoint.x = e.pageX;
        this.editingStartPoint.y = e.pageY;
      };

      /**
       * Handler for editing stoping (by mouseup on drawing canvas)
       * It includes redrawing area by new coords and saving this new coords
       * as own area coords
       *
       * @params e {MouseEvent} - click or keydown event
       */
      Polygon.prototype.onStopEditing = function (e) {
        var editType = app.getEditType();

        this.setCoords(
          this.edit(
            editType,
            e.pageX - this.editingStartPoint.x,
            e.pageY - this.editingStartPoint.y
          )
        ).redraw();

        app.removeAllEvents();
      };

      /**
       * Returns string-representation of polygon
       *
       * @returns {string}
       */
      Polygon.prototype.toString = function () {
        return (
          "Polygon {points: [" +
          this._coords.points
            .map(function (item) {
              return "[" + item.x + ", " + item.y + "]";
            })
            .join(", ") +
          "]}"
        );
      };

      /**
       * Returns html-string of area html element with params of this polygon
       *
       * @returns {string}
       */
      Polygon.prototype.toHTMLMapElementString = function () {
        var str = this._coords.points
          .map(function (item) {
            return item.x + ", " + item.y;
          })
          .join(", ");

        return (
          '<area target="_blank" class="maparea" shape="poly" coords="' +
          str +
          '"' +
          (this._attributes.href
            ? ' href="' + this._attributes.href + '"'
            : "") +
          (this._attributes.alt ? ' alt="' + this._attributes.alt + '"' : "") +
          (this._attributes.title
            ? ' title="' + this._attributes.title + '"'
            : "") +
          " />"
        );
      };

      /**
       * Returns coords for area attributes form
       *
       * @returns {Object} - coordinates of point
       */
      Polygon.prototype.getCoordsForDisplayingInfo = function () {
        return {
          x: this._coords.points[0].x,
          y: this._coords.points[0].y,
        };
      };

      /**
       * Returns true if coords is valid for polygons and false otherwise
       *
       * @static
       * @param coords {Object} - object with coords for new polygon
       * @returns {boolean}
       */
      Polygon.testCoords = function (coords) {
        return coords.points.length >= 3;
      };

      /**
       * Returns true if html coords array is valid for polygons and false otherwise
       *
       * @static
       * @param coords {Array} - coords for new polygon as array [x1, y1, x2, y2, x3, y3, ...]
       * @returns {boolean}
       */
      Polygon.testHTMLCoords = function (coords) {
        return coords.length >= 6 && coords.length % 2 === 0;
      };

      /**
       * Returns polygon coords object from html array
       *
       * @param htmlCoordsArray {Array}
       * @returns {Object} - object with calculated points
       */
      Polygon.getCoordsFromHTMLArray = function (htmlCoordsArray) {
        if (!Polygon.testHTMLCoords(htmlCoordsArray)) {
          throw new Error("This html-coordinates is not valid for polygon");
        }

        var points = [];
        for (var i = 0, c = htmlCoordsArray.length / 2; i < c; i++) {
          points.push({
            x: htmlCoordsArray[2 * i],
            y: htmlCoordsArray[2 * i + 1],
          });
        }

        return {
          points: points,
        };
      };

      /**
       * Returns coords of new point with right angle (or 45 deg) for last line
       * This method recalculates coordinates of new point for
       * last line with (0 | 45 | 90 | 135 | 180 | 225 | 270 | 315) deg
       * For example,
       * for (0 < deg < 23) -> 0 deg
       * for (23 < deg < 67) -> 45 deg
       * for (67 < deg < 90) -> 90 deg etc.
       *
       *         0
       *    315\ | /45
       *        \|/
       * 270 --------- 90
       *        /|\
       *    225/ | \135
       *        180
       *
       * @static
       * @param originalCoords {Object} - Coordinates of this area (without new point)
       * @param newPointCoords {Object} - Coordinates of new point
       * @returns {Object} - Right coordinates for last point
       */
      Polygon.getRightAngleLineLastPointCoords = function (
        originalCoords,
        newPointCoords
      ) {
        var TANGENS = {
            DEG_22: 0.414,
            DEG_67: 2.414,
          },
          lastPointIndex = originalCoords.points.length - 1,
          lastPoint = originalCoords.points[lastPointIndex],
          dx = newPointCoords.x - lastPoint.x,
          dy = -(newPointCoords.y - lastPoint.y),
          tan = dy / dx,
          x = newPointCoords.x,
          y = newPointCoords.y;

        if (dx > 0 && dy > 0) {
          if (tan > TANGENS.DEG_67) {
            x = lastPoint.x;
          } else if (tan < TANGENS.DEG_22) {
            y = lastPoint.y;
          } else {
            Math.abs(dx) > Math.abs(dy)
              ? (x = lastPoint.x + dy)
              : (y = lastPoint.y - dx);
          }
        } else if (dx < 0 && dy > 0) {
          if (tan < -TANGENS.DEG_67) {
            x = lastPoint.x;
          } else if (tan > -TANGENS.DEG_22) {
            y = lastPoint.y;
          } else {
            Math.abs(dx) > Math.abs(dy)
              ? (x = lastPoint.x - dy)
              : (y = lastPoint.y + dx);
          }
        } else if (dx < 0 && dy < 0) {
          if (tan > TANGENS.DEG_67) {
            x = lastPoint.x;
          } else if (tan < TANGENS.DEG_22) {
            y = lastPoint.y;
          } else {
            Math.abs(dx) > Math.abs(dy)
              ? (x = lastPoint.x + dy)
              : (y = lastPoint.y - dx);
          }
        } else if (dx > 0 && dy < 0) {
          if (tan < -TANGENS.DEG_67) {
            x = lastPoint.x;
          } else if (tan > -TANGENS.DEG_22) {
            y = lastPoint.y;
          } else {
            Math.abs(dx) > Math.abs(dy)
              ? (x = lastPoint.x - dy)
              : (y = lastPoint.y + dx);
          }
        }

        return {
          x: x,
          y: y,
        };
      };

      /**
       * Creates new polygon and add drawing handlers for DOM-elements
       *
       * @static
       * @param firstPointCoords {Object} - coords for first point of polyline
       * @returns {Polygon} - created polygon
       */
      Polygon.createAndStartDrawing = function (firstPointCoords) {
        var newArea = new Polygon({
          points: [firstPointCoords],
          isOpened: true,
        });

        app
          .addEvent(
            app.domElements.container,
            "mousemove",
            newArea.onProcessDrawing.bind(newArea)
          )
          .addEvent(
            app.domElements.container,
            "click",
            newArea.onAddPointDrawing.bind(newArea)
          )
          .addEvent(document, "keydown", newArea.onStopDrawing.bind(newArea))
          .addEvent(
            newArea._helpers.points[0]._el,
            "click",
            newArea.onStopDrawing.bind(newArea)
          );

        return newArea;
      };

      /* TODO: this modules will use app.js */
      /* Help block */
      var help = (function () {
        var block = utils.id("help"),
          overlay = utils.id("overlay"),
          close_button = block.querySelector(".close_button");

        function hide() {
          utils.hide(block);
          utils.hide(overlay);
        }

        function show() {
          utils.show(block);
          utils.show(overlay);
        }

        overlay.addEventListener("click", hide, false);

        close_button.addEventListener("click", hide, false);

        return {
          show: show,
          hide: hide,
        };
      })();

      /* For html code of created map */
      var code = (function () {
        var block = utils.id("code"),
          content = utils.id("code_content"),
          close_button = block.querySelector(".close_button");

        close_button.addEventListener(
          "click",
          function (e) {
            utils.hide(block);
            e.preventDefault();
          },
          false
        );

        return {
          print: function () {
            content.innerHTML = app.getHTMLCode(true);
            utils.show(block);
          },
          hide: function () {
            utils.hide(block);
          },
        };
      })();

      /* Edit selected area info */
      var info = (function () {
        var form = utils.id("edit_details"),
          header = form.querySelector("h5"),
          href_attr = utils.id("href_attr"),
          alt_attr = utils.id("alt_attr"),
          title_attr = utils.id("title_attr"),
          save_button = utils.id("save_details"),
          close_button = form.querySelector(".close_button"),
          sections = form.querySelectorAll("p"),
          obj,
          x,
          y,
          temp_x,
          temp_y;

        function changedReset() {
          form.classList.remove("changed");
          utils.foreach(sections, function (x) {
            x.classList.remove("changed");
          });
        }

        function save(e) {
          obj.setInfoAttributes({
            href: href_attr.value,
            alt: alt_attr.value,
            title: title_attr.value,
          });

          obj[
            obj.href
              ? "setStyleOfElementWithHref"
              : "unsetStyleOfElementWithHref"
          ]();

          changedReset();
          unload();

          e.preventDefault();
        }

        function unload() {
          obj = null;
          changedReset();
          utils.hide(form);
        }

        function setCoords(x, y) {
          form.style.left = x + 5 + "px";
          form.style.top = y + 5 + "px";
        }

        function moveEditBlock(e) {
          setCoords(x + e.pageX - temp_x, y + e.pageY - temp_y);
        }

        function stopMoveEditBlock(e) {
          x = x + e.pageX - temp_x;
          y = y + e.pageY - temp_y;
          setCoords(x, y);

          app.removeAllEvents();
        }

        function change() {
          form.classList.add("changed");
          this.parentNode.classList.add("changed");
        }

        save_button.addEventListener("click", save, false);

        href_attr.addEventListener(
          "keydown",
          function (e) {
            e.stopPropagation();
          },
          false
        );
        alt_attr.addEventListener(
          "keydown",
          function (e) {
            e.stopPropagation();
          },
          false
        );
        title_attr.addEventListener(
          "keydown",
          function (e) {
            e.stopPropagation();
          },
          false
        );

        href_attr.addEventListener("change", change, false);
        alt_attr.addEventListener("change", change, false);
        title_attr.addEventListener("change", change, false);

        close_button.addEventListener("click", unload, false);

        header.addEventListener(
          "mousedown",
          function (e) {
            (temp_x = e.pageX), (temp_y = e.pageY);

            app.addEvent(document, "mousemove", moveEditBlock);
            app.addEvent(header, "mouseup", stopMoveEditBlock);

            e.preventDefault();
          },
          false
        );

        return {
          load: function (object, new_x, new_y) {
            obj = object;
            href_attr.value = object.href ? object.href : "";
            alt_attr.value = object.alt ? object.alt : "";
            title_attr.value = object.title ? object.title : "";
            utils.show(form);
            if (new_x && new_y) {
              x = new_x;
              y = new_y;
              setCoords(x, y);
            }
          },
          unload: unload,
        };
      })();

      /* Load areas from html code */
      var from_html_form = (function () {
        var form = utils.id("from_html_wrapper"),
          code_input = utils.id("code_input"),
          load_button = utils.id("load_code_button"),
          close_button = form.querySelector(".close_button");

        function load(e) {
          if (Area.createAreasFromHTMLOfMap(code_input.value)) {
            hide();
          }

          e.preventDefault();
        }

        function hide() {
          utils.hide(form);
        }

        load_button.addEventListener("click", load, false);

        close_button.addEventListener("click", hide, false);

        return {
          show: function () {
            code_input.value = "";
            utils.show(form);
          },
          hide: hide,
        };
      })();

      /* Get image form */
      var get_image = (function () {
        var block = utils.id("get_image_wrapper"),
          close_button = block.querySelector(".close_button"),
          loading_indicator = utils.id("loading"),
          button = utils.id("button"),
          filename = null,
          last_changed = null;

        // Drag'n'drop - the first way to loading an image
        var drag_n_drop = (function () {
          var dropzone = utils.id("dropzone"),
            dropzone_clear_button = dropzone.querySelector(".clear_button"),
            sm_img = utils.id("sm_img");

          function testFile(type) {
            switch (type) {
              case "image/jpeg":
              case "image/gif":
              case "image/png":
                return true;
            }
            return false;
          }

          dropzone.addEventListener(
            "dragover",
            function (e) {
              utils.stopEvent(e);
            },
            false
          );

          dropzone.addEventListener(
            "dragleave",
            function (e) {
              utils.stopEvent(e);
            },
            false
          );

          dropzone.addEventListener(
            "drop",
            function (e) {
              utils.stopEvent(e);

              var reader = new FileReader(),
                file = e.dataTransfer.files[0];
              Emit.$emit("fileimg", file);

              if (testFile(file.type)) {
                dropzone.classList.remove("error");

                reader.readAsDataURL(file);

                reader.onload = function (e) {
                  sm_img.src = e.target.result;
                  sm_img.style.display = "inline-block";
                  filename = file.name;
                  utils.show(dropzone_clear_button);
                  last_changed = drag_n_drop;
                };
              } else {
                clearDropzone();
                dropzone.classList.add("error");
              }
            },
            false
          );

          function clearDropzone() {
            sm_img.src = "";

            utils.hide(sm_img).hide(dropzone_clear_button);

            dropzone.classList.remove("error");

            last_changed = url_input;
          }

          dropzone_clear_button.addEventListener("click", clearDropzone, false);

          return {
            clear: clearDropzone,
            init: function () {
              dropzone.draggable = true;
              this.clear();
              utils.hide(sm_img).hide(dropzone_clear_button);
            },
            test: function () {
              return Boolean(sm_img.src);
            },
            getImage: function () {
              return sm_img.src;
            },
          };
        })();

        /* Set a url - the second way to loading an image */
        var url_input = (function () {
          var url = utils.id("url"),
            url_clear_button = url.parentNode.querySelector(".clear_button");

          function testUrl(str) {
            var url_str = str.trim(),
              temp_array = url_str.split("."),
              ext;

            return true; //se comentarea para cuando se obtiene como blob o data y se agrega el true
            // if(temp_array.length > 1) {
            //     ext = temp_array[temp_array.length-1].toLowerCase();
            //     switch (ext) {
            //         case 'jpg':
            //         case 'jpeg':
            //         case 'gif':
            //         case 'png':
            //             return true;
            //     }
            // }

            // return false;
          }

          function onUrlChange() {
            setTimeout(function () {
              if (url.value.length) {
                utils.show(url_clear_button);
                last_changed = url_input;
              } else {
                utils.hide(url_clear_button);
                last_changed = drag_n_drop;
              }
            }, 0);
          }

          url.addEventListener("keypress", onUrlChange, false);
          url.addEventListener("change", onUrlChange, false);
          url.addEventListener("paste", onUrlChange, false);

          function clearUrl() {
            url.value = "";
            utils.hide(url_clear_button);
            url.classList.remove("error");
            last_changed = url_input;
          }

          url_clear_button.addEventListener("click", clearUrl, false);

          return {
            clear: clearUrl,
            init: function () {
              this.clear();
              utils.hide(url_clear_button);
            },
            test: function () {
              if (testUrl(url.value)) {
                url.classList.remove("error");
                return true;
              } else {
                url.classList.add("error");
              }
              return false;
            },
            getImage: function () {
              var tmp_arr = url.value.split("/");
              filename = tmp_arr[tmp_arr.length - 1];

              return url.value.trim();
            },
          };
        })();

        /* Block init */
        function init() {
          utils.hide(loading_indicator);
          drag_n_drop.init();
          url_input.init();
        }
        init();

        /* Block clear */
        function clear() {
          drag_n_drop.clear();
          url_input.clear();
          last_changed = null;
        }

        /* Selected image loading */
        function onButtonClick(e) {
          if (last_changed === url_input && url_input.test()) {
            app.loadImage(url_input.getImage()).setFilename(filename);
          } else if (last_changed === drag_n_drop && drag_n_drop.test()) {
            app.loadImage(drag_n_drop.getImage()).setFilename(filename);
          }

          e.preventDefault();
        }

        button.addEventListener("click", onButtonClick, false);

        close_button.addEventListener("click", hide, false);

        function show() {
          clear();
          utils.show(block);
        }

        function hide() {
          utils.hide(block);
        }

        /* Returned object */
        return {
          show: function () {
            app.hide();
            show();

            return this;
          },
          hide: function () {
            app.show();
            hide();

            return this;
          },
          showLoadIndicator: function () {
            utils.show(loading_indicator);

            return this;
          },
          hideLoadIndicator: function () {
            utils.hide(loading_indicator);

            return this;
          },
        };
      })();
      get_image.show();

      /* Buttons and actions */
      var buttons = (function () {
        var all = utils.id("nav").getElementsByTagName("li"),
          save = utils.id("save"),
          load = utils.id("load"),
          rectangle = utils.id("rectangle"),
          circle = utils.id("circle"),
          polygon = utils.id("polygon"),
          edit = utils.id("edit"),
          clear = utils.id("clear"),
          from_html = utils.id("from_html"),
          to_html = utils.id("to_html"),
          preview = utils.id("preview"),
          new_image = utils.id("new_image"),
          show_help = utils.id("show_help");

        function deselectAll() {
          utils.foreach(all, function (x) {
            x.classList.remove(Area.CLASS_NAMES.SELECTED);
          });
        }

        function selectOne(button) {
          deselectAll();
          button.classList.add(Area.CLASS_NAMES.SELECTED);
        }

        function onSaveButtonClick(e) {
          // Save in localStorage
          app.saveInLocalStorage();

          e.preventDefault();
        }

        function onLoadButtonClick(e) {
          // Load from localStorage
          app.clear().loadFromLocalStorage();

          e.preventDefault();
        }

        function onShapeButtonClick(e) {
          // shape = rect || circle || polygon
          app
            .setMode("drawing")
            .setDrawClass()
            .setShape(this.id)
            .deselectAll()
            .hidePreview();
          info.unload();
          selectOne(this);

          e.preventDefault();
        }

        function onClearButtonClick(e) {
          // Clear all
          if (confirm("Clear all?")) {
            app
              .setMode(null)
              .setDefaultClass()
              .setShape(null)
              .clear()
              .hidePreview();
            deselectAll();
          }

          e.preventDefault();
        }

        function onFromHtmlButtonClick(e) {
          // Load areas from html
          from_html_form.show();

          e.preventDefault();
        }

        function onToHtmlButtonClick(e) {
          // Generate html code only
          info.unload();
          code.print();

          e.preventDefault();
        }

        function onPreviewButtonClick(e) {
          if (app.getMode() === "preview") {
            app.setMode(null).hidePreview();
            deselectAll();
          } else {
            app.deselectAll().setMode("preview").setDefaultClass().preview();
            selectOne(this);
          }

          e.preventDefault();
        }

        function onEditButtonClick(e) {
          if (app.getMode() === "editing") {
            app.setMode(null).setDefaultClass().deselectAll();
            deselectAll();
            utils.show(domElements.svg);
          } else {
            app.setShape(null).setMode("editing").setEditClass();
            selectOne(this);
          }
          app.hidePreview();
          e.preventDefault();
        }

        function onNewImageButtonClick(e) {
          // New image - clear all and back to loading image screen
          if (confirm("Descartar los cambios?")) {
            app.setMode(null)
              .setDefaultClass()
              .setShape(null)
              .setIsDraw(false)
              .clear()
              .hide()
              .hidePreview();
            deselectAll();
            get_image.show();
            document.getElementById('imgInput').value = null
          }

          e.preventDefault();
        }

        function onShowHelpButtonClick(e) {
          help.show();

          e.preventDefault();
        }

        save.addEventListener("click", onSaveButtonClick, false);
        load.addEventListener("click", onLoadButtonClick, false);
        rectangle.addEventListener("click", onShapeButtonClick, false);
        circle.addEventListener("click", onShapeButtonClick, false);
        polygon.addEventListener("click", onShapeButtonClick, false);
        clear.addEventListener("click", onClearButtonClick, false);
        from_html.addEventListener("click", onFromHtmlButtonClick, false);
        to_html.addEventListener("click", onToHtmlButtonClick, false);
        preview.addEventListener("click", onPreviewButtonClick, false);
        edit.addEventListener("click", onEditButtonClick, false);
        new_image.addEventListener("click", onNewImageButtonClick, false);
        show_help.addEventListener("click", onShowHelpButtonClick, false);
      })();
    })();
  },
};
</script>

<style>
.clear {
  clear: both;
}
.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}
#noscript {
  text-align: center;
  display: block;
  font-size: 20px;
  padding: 5px 0;
  background: #f00;
}
#header {
  background: #000;
  padding: 5px 0;
  position: fixed;
  z-index: 1001;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px 2px;
}
#logo {
  margin-right: 10px;
  margin-left: 10px;
  margin-top: -4px;
  margin-bottom: -4px;
  display: inline-block;
  vertical-align: top;
}
#logo a:link,
#logo a:visited {
  color: #32c832;
}
#logo a:hover {
  color: #fff;
}
#logo img {
  display: block;
}
#nav,
#nav ul {
  display: inline;
  vertical-align: middle;
}
#nav li {
  margin-right: 5px;
  display: inline;
}
#nav a:link,
#nav a:visited {
  border: 1px solid #fff;
  border-radius: 3px;
  font-size: 10px;
  padding: 5px 10px;
  display: inline-block;
  color: #fff;
}
#nav a:hover,
#nav a:active {
  border: 1px solid #32c832;
  color: #32c832;
}
#nav a:active,
#nav .selected a {
  background: #fff;
  color: #000;
  box-shadow: 0 0 1px #222 inset;
  border: 1px solid #fff;
}
#coords {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #fff;
  font-size: 11px;
}
#debug {
  color: #eee;
  position: absolute;
  top: 10px;
  right: 100px;
  z-index: 1001;
  font-size: 11px;
}
#wrapper {
  position: relative;
}
#image_wrapper {
  padding: 45px 0 10px;
}
#image {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px 2px;
  display: none;
}
.draw#image {
  cursor: crosshair;
}
#image map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}
#img {
  position: relative;
  z-index: 1;
}
#code {
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  font-family: monospace;
  font-size: 11px;
  line-height: 1.3;
  width: 600px;
  position: fixed;
  left: 3%;
  width: 94%;
  bottom: 10px;
  z-index: 1000;
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px 2px;
  display: none;
  border-radius: 3px;
}
#code_content {
  padding: 10px;
}
.close_button {
  width: 10px;
  height: 10px;
  display: block;
  background: #fff
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACbgAAAm4Bt/774AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABKSURBVAiZfc2xCYBAFATR90WwiSvUzDOyCcuzCaM1UMHIgc1mmcKOI0mHqupoIw4sVTW5mbFKAhvybEti8EN/zc+zj2hYP/ET7QIK9BpShkyrPwAAAABJRU5ErkJggg==)
    50% 50% no-repeat;
  position: absolute;
  top: 10px;
  right: 10px;
  box-shadow: 0 0 1px #222 inset;
  border-radius: 1px;
  cursor: pointer;
}
#about {
  position: absolute;
  top: 10px;
  left: 0;
  width: 100%;
  font-family: "News Cycle";
  font-size: 24px;
  background: transparent;
  padding: 2px 10px 5px;
  -o-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #000;
}
#get_image_wrapper {
  padding: 35px 0;
  position: relative;
  z-index: 1002;
  display: none;
}
#get_image {
  width: 200px;
  margin: 0 auto;
  font-size: 16px;
  text-align: center;
  background: #fff;
  padding: 20px 30px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px 2px;
  position: relative;
}
#get_image .close_button {
  background: #000
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACbgAAAm4Bt/774AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABKSURBVAiZdc2xDYAwAAPBA0ViiQxKR6hgCMZjCSpTEAkavnxL7yHJgRPNQ0MtXS6Y+jBjlUSSLS9bEqMfSm/O2D+pq6Bi/ZxfqDfkbiIp0Zzd1AAAAABJRU5ErkJggg==)
    50% 50% no-repeat;
  box-shadow: 0 0 1px #eee inset;
  border-radius: 2px;
}
#logo_get_image {
  margin-bottom: 20px;
}
#loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 20px;
  background: rgba(255, 255, 255, 0.95)
    url(data:image/gif;base64,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)
    50% 50% no-repeat;
  z-index: 3;
  border-radius: 5px;
  line-height: 3;
}
#get_image b {
  display: block;
  font-size: 25px;
  margin: 10px 0;
}
#get_image label {
  display: block;
  margin-bottom: 5px;
}
#button {
  margin-top: 20px;
  font-size: 21px;
}
#dropzone {
  border: 2px dashed #999;
  width: 200px;
  height: 200px;
  background: #fafafa
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAiCAYAAADCp/A1AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAApjAAAKYwGDMomsAAAAB3RJTUUH3AkYCxg3B2a5QgAAAKtJREFUWMPt17sNgDAMRdE8tsj+w2UM6CiQEv9jIvm1COl0uUZbbIxxt03rvWP27WoHrJCFLGQhC1nIQr7DzohQI3fXjqaOkJFl0nxDVj9K+hKZocsNYGQXOafQ8YfTgTohcMKNA+rnHdAVkIWMhlJANjIKygGKkN5QLlCM9IJKgCqkFSoFqpFaqAZoQkqhWqAZyYVagC5ICmoFuiFnUA+gK/IL9QKGLOJlegBB2VeWydvIHgAAAABJRU5ErkJggg==)
    50% 50% no-repeat;
  overflow: hidden;
  text-align: center;
  line-height: 200px;
  position: relative;
}
.error#dropzone {
  border: 2px dashed #f00;
}
.clear_button {
  display: block;
  height: 16px;
  width: 16px;
  position: absolute;
  top: 6px;
  right: 6px;
  line-height: 1 !important;
  overflow: hidden;
  cursor: pointer;
  text-indent: -9999px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAD1QAAA9UBZ3cOpgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAG4SURBVDiNrZOxattQFIa/c5UMtsBbIbMRQZ7iyFC/QjEesqoPYPAUsnQoaAp472RI92jJEGjaNwjFpY68RWQIXQoudocKVEPj29shuo6Fm9JCv/Gi7+ic/54rxhjWaX5o7jo/nedAC6EFgGEMjLXSp5Onk5v178UWEESCUXAIDIAKv2cBvLxqX70y3ItijEEQ2R/tXwjSeUQsYTDvknbSNRijAIJRcChIp+E2iOoRXtXbkLyqR1SPaLgNBOkU3SJ7o71dxzgToBLVIw6eHJAtM/ppnzRPAfBdn6E/pLZV43x2zvHtMcBCi26qIrAKQDyNyZYZta0aQ3+I7/olOVtmxNPYNlVxcEIJ3gdvELr2dF3IdQ6A67gbXRVhXKjVVRWkeUo/7ZPrHNdxcR2XXOebMoDQUn+T+p9QxZKssCPYP9tObCYlDGMFDwW8qlcKrHfdo3fdKwVbumLFR6WVPuV+wwh3wpVsZ7aZ2CLhTmj1hUbHzvT19OvJ55MceDb7MUOJYvBpwM33h5Wf3825/HbJttrm7MsZ87s5wIuknbz9P6tsMCZpJ13gyI7zCAvgyMqw9hot//qcfwEDGehh48P3mQAAAABJRU5ErkJggg==);
  z-index: 2;
}
#dropzone img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
#url_wrapper {
  position: relative;
  display: block;
}
#url {
  border: 2px solid #999;
  border-radius: 3px;
  background: #fff;
  padding: 2px 25px 2px 5px;
  width: 100%;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2) inset;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.error#url {
  border: 2px solid #f00;
}
#edit_details {
  position: absolute;
  top: 100px;
  left: 100px;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 5px;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px 1px;
  display: none;
  z-index: 1000;
  color: black;
  font-size: 0px;
}
#edit_details h5 {
  margin-bottom: 10px;
  font-size: 14px;
  cursor: move;
}
.changed#edit_details h5,
p.changed label {
  color: #32c832;
}
#edit_details p {
  margin-bottom: 10px;
}
#edit_details label {
  font-size: 11px;
  display: block;
  margin-bottom: 2px;
}
#edit_details input[type="text"] {
  background: #fff;
  font-size: 12px;
  font-family: sans-serif;
  padding: 2px 5px;
  width: 120px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.5) 0 1px 2px inset;
}
.changed#edit_details button {
  box-shadow: rgba(50, 200, 50, 1) 0 0 1px 2px;
}
#help {
  display: none;
  width: 400px;
  border-radius: 3px;
  background: #fff;
  position: absolute;
  top: 35px;
  left: 50%;
  margin-left: -200px;
  z-index: 1003;
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px 2px;
}
#help .txt {
  padding: 20px 20px 5px;
  line-height: 1.4;
}
.txt p {
  margin-bottom: 3px;
}
#help section {
  margin-bottom: 20px;
}
#help .close_button {
  background: #000
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACbgAAAm4Bt/774AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABKSURBVAiZdc2xDYAwAAPBA0ViiQxKR6hgCMZjCSpTEAkavnxL7yHJgRPNQ0MtXS6Y+jBjlUSSLS9bEqMfSm/O2D+pq6Bi/ZxfqDfkbiIp0Zzd1AAAAABJRU5ErkJggg==)
    50% 50% no-repeat;
  box-shadow: 0 0 1px #eee inset;
  border-radius: 2px;
}
#help h2 {
  margin-bottom: 5px;
}
#help footer {
  color: #999;
  font-size: 10px;
  padding: 0 20px 20px;
  line-height: 1.3;
}
#help footer a {
  color: #777;
  text-decoration: underline;
}
.key {
  background: #f5f5f5;
  color: #555;
  text-shadow: 0 0 1px #eee;
  padding: 1px 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  display: inline-block;
  min-width: 16px;
  text-align: center;
  font-size: 11px;
  box-shadow: 1px 1px 0 rgba(255, 255, 255, 1) inset,
    -1px -1px 0 rgba(0, 0, 0, 0.08) inset;
  overflow: hidden;
  cursor: default;
  vertical-align: middle;
}
.key:active {
  padding: 2px 5px 0;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.08) inset,
    -1px -1px 0 rgba(255, 255, 255, 1) inset;
}
#overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1002;
  background: #000;
  opacity: 0.5;
  display: none;
}
#from_html_wrapper {
  display: none;
  width: 500px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.9);
  position: absolute;
  top: 35px;
  left: 50%;
  margin-left: -250px;
  z-index: 1002;
  color: #fff;
}
#from_html_wrapper .close_button {
  background: #000
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACbgAAAm4Bt/774AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABKSURBVAiZdc2xDYAwAAPBA0ViiQxKR6hgCMZjCSpTEAkavnxL7yHJgRPNQ0MtXS6Y+jBjlUSSLS9bEqMfSm/O2D+pq6Bi/ZxfqDfkbiIp0Zzd1AAAAABJRU5ErkJggg==)
    50% 50% no-repeat;
  box-shadow: 0 0 1px #eee inset;
  border-radius: 2px;
}
#from_html_form {
  padding: 20px;
}
#from_html_form h5 {
  margin-bottom: 15px;
}
#from_html_form label {
  display: block;
  font-size: 12px;
}
#from_html_form textarea {
  border: 0px;
  border-radius: 3px;
  background: #fff;
  padding: 2px 5px;
  margin-bottom: 5px;
  width: 100%;
  height: 100px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2) inset;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: monospace;
  font-size: 11px;
  line-height: 1.3;
}

/* CSS for SVG-elements */

#svg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: inline-block;
}
#svg rect {
  stroke-width: 3px;
  stroke: #f00;
  fill: rgba(255, 255, 255, 0.3);
}
#svg rect.with_href {
  fill: rgba(0, 0, 0, 0.3);
}
.edit > #svg rect:hover {
  fill: rgba(50, 200, 50, 0.3);
}
#svg rect.active {
  fill: rgba(0, 0, 0, 0.5);
}
#svg circle {
  stroke-width: 3px;
  stroke: #0f0;
  fill: rgba(255, 255, 255, 0.3);
}
#svg circle.with_href {
  fill: rgba(0, 0, 0, 0.3);
}
.edit > #svg circle:hover {
  fill: rgba(50, 200, 50, 0.3);
}
#svg polyline,
#svg polygon {
  stroke-width: 3px;
  stroke: #00f;
  fill: rgba(255, 255, 255, 0.3);
}
#svg polygon.with_href {
  fill: rgba(0, 0, 0, 0.3);
}
.edit > #svg polygon:hover {
  fill: rgba(50, 200, 50, 0.3);
}
#svg .selected {
  fill: rgba(50, 200, 50, 0.5) !important;
}
#svg rect.helper {
  fill: #fff;
  stroke: #000;
  stroke-width: 2px;
}
#svg rect.helper:hover {
  fill: #f00;
}
.edit > #svg rect,
.edit > #svg circle,
.edit > #svg polygon {
  cursor: move;
}
.edit > #svg .pointer {
  cursor: pointer;
}
.edit > #svg .e-resize {
  cursor: e-resize;
}
.edit > #svg .ne-resize {
  cursor: ne-resize;
}
.edit > #svg .nw-resize {
  cursor: nw-resize;
}
.edit > #svg .n-resize {
  cursor: n-resize;
}
.edit > #svg .se-resize {
  cursor: se-resize;
}
.edit > #svg .sw-resize {
  cursor: sw-resize;
}
.edit > #svg .s-resize {
  cursor: s-resize;
}
.edit > #svg .w-resize {
  cursor: w-resize;
}
</style>
